
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DatosService } from './services/datos.service';
import { AuthService } from 'src/data/services/auth/auth.service';
import { AuthStatus } from './models/auth-status.enum';
import { FaviconService } from './services/favicon.service';
import { SessionTimerService } from 'src/data/services/auth/session-timer.service';
import { UsuarioAuthDataService } from './services/usuario-auth-data.service';
import { UsuarioAuth } from './models/userAuth.model';
import { LoggerService } from './core/logger.service';
import { FloatingLabelService } from './core/shared/floating-label.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'podo-energycenter';

  datosService = inject(DatosService);
  authService = inject(AuthService);
  router = inject(Router)
  sessionTimerService = inject(SessionTimerService);
  faviconService = inject(FaviconService);
  usuarioAuthDataService = inject(UsuarioAuthDataService);
  floatingLabelService = inject(FloatingLabelService);

  private usuarioAuth!: UsuarioAuth;

  public authStatusEffect = effect(() => {

    this.logger.debug(this.authService)
    switch(this.authService.authStatus()) {
      case AuthStatus.notAuthenticated:
        this.faviconService.establecerFavicon('./assets/images/icono_energy.png');
        this.router.navigateByUrl('/login');
        this.sessionTimerService.clearTimers();
        break;
      case AuthStatus.authenticated:
        // this.faviconService.establecerFavicon(this.datosService.user.data.channel.logo);
        this.faviconService.establecerFavicon('./assets/images/icono_energy.png');
        this.sessionTimerService.startInactivityTimer();
    }
  })

  constructor(
    translate: TranslateService,
    private logger: LoggerService
    ) {

      translate.setDefaultLang('es');
      translate.use('es');

    }

  ngOnInit() {
    this.floatingLabelService.start();
    this.usuarioAuth = this.usuarioAuthDataService.usuarioAuth();

    if(Object.keys(this.usuarioAuth).length > 0) {
      document.documentElement.style.setProperty('--primary-color', this.usuarioAuth?.canal.colorPrimario);
    }

  }


  setFavicon(imgUrl: any) {
    const newFavicon = document.createElement('link') as HTMLLinkElement;
    newFavicon.rel = 'icon';
    newFavicon.type = 'image/png';
    newFavicon.href = imgUrl;

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(newFavicon);
  }

}


